import { render } from "./Facturas_ProveedorView.vue?vue&type=template&id=acc44ff0"
import script from "./Facturas_ProveedorView.vue?vue&type=script&lang=js"
export * from "./Facturas_ProveedorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__